import * as React from 'react';
import { SVGProps } from 'react';

const IconTable2SizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.333 2c0-.368.299-.667.667-.667h12c.368 0 .667.299.667.667v12a.667.667 0 0 1-.667.667H2A.667.667 0 0 1 1.333 14V2Zm1.334 4.667v2.667h4.667V6.667H2.667Zm6 0v2.667h4.667V6.667H8.667Zm4.667-1.333H8.667V2.667h4.667v2.667Zm-6-2.667v2.667H2.667V2.667h4.667Zm6 8H8.667v2.667h4.667v-2.667Zm-6 2.667v-2.667H2.667v2.667h4.667Z"
    />
  </svg>
);
export default IconTable2SizeS;
